import PropTypes from "prop-types";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";
import { useState } from "react"; // Import useState to manage active row
import Clock from "../../ui/Clock";
import RenderAvatarSvg from "../others/RenderAvatarSvg";
import NoteOutlinedIcon from "@mui/icons-material/NoteOutlined"; // Import the Note icon

const ProfileTasksSection = ({ userTaskManager }) => {
  const [activeTaskKey, setActiveTaskKey] = useState(null); // Track the active row

  // Get task keys that start with "t" and filter out those without a valid serTitle
  const taskKeys = userTaskManager
    ? Object.keys(userTaskManager)
        .filter((key) => key.startsWith("t") && userTaskManager[key]?.serTitle) // Check for valid serTitle
        .reverse() // Reverse the order from t20 to t1
    : []; // Return an empty array if userTaskManager is undefined

  return (
    <div className="profile-TasksSection">
      <Box
        className="max-w-md mx-auto"
        style={{
          position: "fixed", // Keep it fixed along with the footer
          bottom: "55px", // Adjust to stay above footer
          left: "10px",
          right: "10px",
          height: "200px", // Customize height as needed
          backgroundColor: "#f5f5f5",
          border: "1px solid #e5e5e5",
          borderBottom: "none",
          borderTopLeftRadius: "30px", // Rounded top-left corner
          borderTopRightRadius: "30px", // Rounded top-right corner
          padding: "10px",
        }}
      >
        <div className="profile-task-header flex flex-row space-x-1 text-xs justify-center gap-2 px-5">
          <Clock />
        </div>

        {/* condition to check if userTaskManager is Undefined */}
        {userTaskManager ? (
          <List
            className="profile-task-list"
            sx={{
              overflowY: "auto", // Enable vertical scrolling
              overflowX: "hidden", // Disable horizontal scrolling
              maxHeight: "100%", // Set a height limit for the scrollable area
            }}
          >
            {taskKeys.map((key) => {
              const task = userTaskManager[key];
              const isActive = activeTaskKey === key; // Check if this task is active

              // Only show the task if serTitle is not "RESET"
              return (
                task.serTitle !== "RESET" && (
                  <ListItem
                    key={key}
                    className="task-row"
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "2px 0",
                      backgroundColor: isActive ? "#f5f5f5" : "inherit", // Change color when active
                      cursor: "pointer", // Show pointer on hover
                      "&:hover": {
                        backgroundColor: "#f1f1f1", // Light grey on hover
                      },
                    }}
                    onClick={() => setActiveTaskKey(key)} // Set the active row on click
                  >
                    <ListItemAvatar>
                      <RenderAvatarSvg
                        shape={task.serAvatar.shape}
                        color1={task.serAvatar.color1}
                        color2={task.serAvatar.color2}
                        size={35}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      primary={task.serTitle}
                      secondary={`Amount: ${task.serAmount || "N/A"}`} // Display amount below title
                      primaryTypographyProps={{
                        fontWeight: "bold",
                        fontSize: "12px",
                      }}
                      secondaryTypographyProps={{
                        fontSize: "10px",
                      }}
                      sx={{ flex: "1", fontSize: "10px" }} // Adjusting the space between avatar and text
                    />

                    {/* Replace "Note" with an icon and add Tooltip */}
                    {task.serNote && (
                      <Tooltip title={task.serNote} placement="top">
                        <IconButton sx={{ padding: "0" }}>
                          <NoteOutlinedIcon sx={{ fontSize: "16px" }} />
                        </IconButton>
                      </Tooltip>
                    )}

                    <Typography
                      variant="body2"
                      sx={{ fontSize: "10px", paddingLeft: "5px" }}
                    >
                      {task.serStation ? "Station: " + task.serStation : ""}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        minWidth: "30px",
                        textAlign: "right",
                        fontSize: "14px",
                      }}
                    >
                      {key.toUpperCase()}{" "}
                      {/* Display task key (T1, T2, etc.) */}
                    </Typography>
                  </ListItem>
                )
              );
            })}
          </List>
        ) : (
          <p className="text-xs flex padding-2 justify-center">
            Waiting for manager update...
          </p>
        )}
      </Box>
    </div>
  );
};

ProfileTasksSection.propTypes = {
  userTaskManager: PropTypes.object,
};

export default ProfileTasksSection;
